import React from 'react';
import 'twin.macro';

interface BlockquoteProps {
  author?: string;
}

const Blockquote: React.FC<BlockquoteProps> = ({ children, author }) => (
  <blockquote tw="rounded-lg bg-blue text-xl leading-relaxed font-bold text-white p-4 max-w-7xl">
    <div>{children}</div>
    {author && <cite tw="text-lg text-white font-bold">{author}</cite>}
  </blockquote>
);

export default Blockquote;
